import { collection, getDocs, query, where } from 'firebase/firestore'
import React, { useEffect, useState } from 'react'
import { Bar, Line } from 'react-chartjs-2'
import { useLocation } from 'react-router-dom'
import Header from '../../components/Header'
import { db } from '../../utitilties/firebase'
import SurveyItem from './components/SurveyItem'
import './surveys.css'
import {
    Chart as ChartJS,
    CategoryScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    PointElement,
    LineElement,
    LinearScale
} from 'chart.js';
import { getTotalScore } from '../../helpers/getTotalScore'
import ReactModal from 'react-modal'
import AddSurveyModal from './components/AddSurveyModal'
ChartJS.register(LinearScale)


function Surveys() {

    ChartJS.register(
        CategoryScale,

        BarElement,
        Title,
        Tooltip,
        Legend, PointElement, LineElement
    );

    const { client, therapist } = (useLocation().state)
    console.log(useLocation().state)

    const [surveys, setSurveys] = useState([])
    const [showAddSurveyModal, setShowAddSurveyModal] = useState(false)

    const getTherapists = async () => {
        const q = query(collection(db, "Forms"), where("userId", "==", client.id));

        const querySnapshot = await getDocs(q);
        let tempSurveys = []
        querySnapshot.forEach((doc) => {
            tempSurveys.push({ id: doc.id, ...doc.data(), })
        })



        tempSurveys.sort((a, b) => a.timestamp - b.timestamp)


        console.log(tempSurveys, 'lkdfjlksjdflj')
        setSurveys(tempSurveys)

    }


    useEffect(() => {
        if (client.id) {
            getTherapists()
        }
    }, [client.id])


    return (
        <div style={{ padding: 50 }} >
            <Header label={client.name} right={<div className="btn"
                onClick={() => setShowAddSurveyModal(true)}
            >
                <p>Add survey</p>
            </div>} />

            <div className='surveys' >
                <div className='surveys_sub'>
                    <h2>Surveys</h2>
                    <div style={{ marginTop: 20 }} >
                        {
                            surveys.map(survey => <SurveyItem therapist={therapist} survey={survey} />)
                        }
                    </div>
                </div>


                <div className='surveys_sub'>
                    <h2>Statistics</h2>
                    <div style={{ marginTop: 20, marginBottom: 25, padding: 15, paddingBottom: 10, border: '1px solid black', height: 150 }} >
                        <p style={{ marginBottom: 10 }} >Short Term History</p>
                        <div style={{ height: 125 }} >
                        <Bar
                            height={100}
                            style={{ height: 100, }}
                            options={{
                                responsive: true,
                                scales: {
                                    y: {

                                        display: true, // Hide Y axis labels

                                    },
                                    x: {
                                        display: false // Hide X axis labels
                                    }
                                },
                                plugins: {

                                    legend: {
                                        position: 'top',
                                        display: false
                                    },

                                    title: {
                                        display: false,
                                        text: 'Chart.js Bar Chart',
                                    },


                                },
                            }}
                            data={{
                                labels: surveys?.filter((survey) => survey.timestamp.toDate() > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).map((survey) => ''),
                                datasets: [
                                    {
                                        label: 'Dataset 1',
                                        data: surveys?.filter((survey) => survey.timestamp.toDate() > new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).map((survey) => getTotalScore(survey.answers)),
                                        backgroundColor: 'rgba(255, 99, 132, 0.5)',
                                        barThickness: 20,


                                    },

                                ],
                            }}

                        />
                        </div>
                    </div>

                    <div style={{ padding: 15, border: '1px solid black', height: 150, marginBottom: 10, }}>
                        <p>Long Term History</p>

                        <Line
                            options={{
                                responsive: true,
                                scales: {
                                    y: {

                                        display: true, // Hide Y axis labels

                                    },
                                    x: {
                                        display: true // Hide X axis labels
                                    }
                                },
                                plugins: {

                                    legend: {
                                        position: 'top',
                                        display: false
                                    },

                                    title: {
                                        display: false,
                                        text: 'Chart.js Bar Chart',
                                    },


                                },
                            }}
                            data={{
                                labels: surveys?.map((survey) => ''),
                                datasets: [
                                    {
                                        label: 'Dataset 1',
                                        data: surveys?.map((survey) => getTotalScore(survey.answers)),
                                        backgroundColor: 'rgba(255, 99, 132, 0.5)',
                                        barThickness: 20,

                                    },

                                ],
                            }}
                        />
                    </div>
                    <div style={{ padding: 15, border: '1px solid black', marginBottom: 10, }} >
                        <p>Surveys Completed : {surveys.length}</p>
                    </div>
                </div>
            </div>
            <ReactModal
                isOpen={showAddSurveyModal}
                onRequestClose={() => setShowAddSurveyModal(null)}
                style={{
                    content: {
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        transform: 'translate(-50%, -50%)',
                        // width: '30%',
                        // height: '90vh'
                    },
                    overlay: {
                        background: "#DCDCDC80",

                    }
                }}
                contentLabel="Example Modal"

            >
                <AddSurveyModal onClose={() => setShowAddSurveyModal(false)} client={client} therapist={therapist} />
            </ReactModal>
        </div>
    )
}

export default Surveys